/**
 * Default settings values
 *
 * These defaults are used when the server doesn't provide a value.
 * Settings are namespaced with underscores (e.g., venue_maxGalleryImages).
 *
 * @author Matt Kenefick <matt@polymermallard.com>
 * @package App/Service/Setting
 * @project ChalkySticks Web App
 */
export const defaults: Record<string, any> = {
	feed_refreshInterval: 60000,
	venue_defaultZoomLevel: 12,
	venue_maxGalleryImages: 1,
};

/**
 * Get a single default value
 *
 * @param string key
 * @return any
 */
export function getDefault(key: string): any {
	return defaults[key];
}

/**
 * Get all defaults as a new object
 *
 * @return Record<string, any>
 */
export function getDefaults(): Record<string, any> {
	return { ...defaults };
}
